import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import arrow from '@/assets/images/arrow-right-circle.svg'
import { Link } from 'react-router-dom'

type TSublinksMenu = {
  title: string
  onClose: () => void
  sublinks: {
    anchor: string
    link?: string
    href?: string
  }[]
}

export const SubLinksMenu = ({ title, sublinks, onClose }: TSublinksMenu) => {
  const [isOpen, setIsOpen] = useState<boolean>(false)
  const { t } = useTranslation()

  const onCloseSubmenu = () => {
    onClose()
    setIsOpen(false)
  }

  return (
    <>
      <button
        onClick={() => {
          setIsOpen((prev) => !prev)
        }}
        className="text-sm transition-all leading-[140%] flex items-center justify-between w-full text-xl3 font-semibold"
      >
        <span>{t(title as any)}</span>
        <img
          className={`size-10 ${isOpen ? 'rotate-[270deg]' : ''}`}
          width="40"
          height="40"
          src={arrow}
          alt="link"
        />
      </button>
      <ul
        className={`grid transition-[grid-template-rows] duration-300 ease-in-out ${
          isOpen ? 'grid-rows-[1fr]' : 'grid-rows-[0fr]'
        }`}
      >
        <div className="overflow-hidden">
          {sublinks.map((subItem) => (
            <li key={subItem.anchor} className="py-2">
              {subItem.link && (
                <Link
                  to={subItem.link}
                  onClick={onCloseSubmenu}
                  className="text-base text-[#5F626F]"
                >
                  {t(subItem.anchor as any)}
                </Link>
              )}
              {subItem.href && (
                <a
                  href={subItem.href}
                  target="_blank"
                  rel="noreferrer noopener"
                  onClick={onCloseSubmenu}
                  className="text-base text-[#5F626F]"
                >
                  {t(subItem.anchor as any)}
                </a>
              )}
            </li>
          ))}
        </div>
      </ul>
    </>
  )
}
